// src/admin/data/initialQuestionBankData.js

export const prelimsSubjectFolders = [
  "Polity",
  "History",
  "Geography",
  "Indian Economy",
  "Environment",
  "Science & Technology",
  "Current Affairs",
  "Art & Culture",
];

export const mainsStructure = {
  "GS Paper I": [
    "History",
    "Geography",
    "Indian Society",
  ],
  "GS Paper II": [
    "Indian Polity",
    "Governance",
    "International Relations",
  ],
  "GS Paper III": [
    "Indian Economy",
    "Environment",
    "Science & Technology",
    "Internal Security",
  ],
  "GS Paper IV": [
    "Ethics",
    "Integrity",
    "Aptitude",
  ],
};

export const initialPrelimsQuestionBank = [
  {
    id: "pq-1",
    questionNumber: 1,
    questionText: "With reference to the Indian Constitution, consider the following statements regarding the Attorney-General for India:\n1. He is appointed by the President of India under Article 76.\n2. In the performance of his duties, he has the right of audience in all courts in the territory of India.\n3. He has the right to vote in parliamentary proceedings.\nWhich of the statements given above is/are correct?",
    options: {
      A: "1 and 2 only",
      B: "2 and 3 only",
      C: "1 and 3 only",
      D: "1, 2 and 3",
    },
    correctAnswer: "A",
    subject: "Polity",
    topic: "Constitutional Bodies & Article 76",
    difficulty: "Medium",
    explanation: "Under Article 76, the Attorney-General is appointed by the President and has the right of audience in all courts in India. Under Article 88, he can speak and take part in Parliament proceedings but cannot vote.",
    dateAdded: "2026-10-25",
    status: "Active",
  },
  {
    id: "pq-2",
    questionNumber: 2,
    questionText: "Which of the following bodies is responsible for recommending the distribution of net proceeds of taxes between the Union and the States?",
    options: {
      A: "NITI Aayog",
      B: "Finance Commission",
      C: "Goods and Services Tax Council",
      D: "Inter-State Council",
    },
    correctAnswer: "B",
    subject: "Polity",
    topic: "Fiscal Federalism & Finance Commission",
    difficulty: "Easy",
    explanation: "Under Article 280 of the Constitution, the Finance Commission makes recommendations regarding the distribution of net tax proceeds between the Union and the States.",
    dateAdded: "2026-10-26",
    status: "Active",
  },
  {
    id: "pq-3",
    questionNumber: 3,
    questionText: "With reference to the Ancient Indian History, the terms 'Kulyavapa' and 'Dronavapa' denote:",
    options: {
      A: "Measurement of land",
      B: "Coins of different denominations",
      C: "Classification of urban land",
      D: "Religious rituals during Vedic sacrifices",
    },
    correctAnswer: "A",
    subject: "History",
    topic: "Gupta Administration & Land Revenue",
    difficulty: "Medium",
    explanation: "In the Gupta period, terms like Kulyavapa, Dronavapa, and Nivartana were used to designate land measurements for agrarian and revenue purposes.",
    dateAdded: "2026-10-27",
    status: "Active",
  },
  {
    id: "pq-4",
    questionNumber: 4,
    questionText: "Consider the following statements regarding the Rivers of Peninsular India:\n1. The Godavari river rises from Trimbakeshwar in the Nashik district of Maharashtra.\n2. The Cauvery river basin is shared by Tamil Nadu, Karnataka, Kerala and Puducherry.\nWhich of the statements given above is/are correct?",
    options: {
      A: "1 only",
      B: "2 only",
      C: "Both 1 and 2",
      D: "Neither 1 nor 2",
    },
    correctAnswer: "C",
    subject: "Geography",
    topic: "Peninsular Drainage Systems",
    difficulty: "Medium",
    explanation: "Both statements are correct. The Godavari rises at Trimbakeshwar, and the Cauvery river basin spans Karnataka, Kerala, Tamil Nadu, and the UT of Puducherry.",
    dateAdded: "2026-10-28",
    status: "Active",
  },
  {
    id: "pq-5",
    questionNumber: 5,
    questionText: "Consider the following statements regarding the Minerals Security Partnership (MSP):\n1. It is an initiative of the International Energy Agency (IEA).\n2. India is a member of the Minerals Security Partnership.\nWhich of the statements given above is/are correct?",
    options: {
      A: "1 only",
      B: "2 only",
      C: "Both 1 and 2",
      D: "Neither 1 nor 2",
    },
    correctAnswer: "B",
    subject: "Indian Economy",
    topic: "Critical Minerals & Supply Chains",
    difficulty: "Hard",
    explanation: "MSP is a US-led collaboration aimed at accelerating the development of diverse critical energy mineral supply chains. India joined the partnership in June 2023.",
    dateAdded: "2026-10-28",
    status: "Active",
  },
  {
    id: "pq-6",
    questionNumber: 6,
    questionText: "Which one of the following best describes the term 'Blue Carbon'?",
    options: {
      A: "Carbon captured by industrial scrubbers using synthetic blue dyes",
      B: "Carbon captured by oceans and coastal ecosystems",
      C: "Carbon sequestered in deep underground polar ice sheets",
      D: "Carbon emissions from offshore maritime cargo transport",
    },
    correctAnswer: "B",
    subject: "Environment",
    topic: "Carbon Sequestration & Marine Ecology",
    difficulty: "Easy",
    explanation: "Blue carbon is the carbon captured by coastal and marine ecosystems such as mangroves, tidal marshes, and seagrass meadows.",
    dateAdded: "2026-10-29",
    status: "Active",
  },
  {
    id: "pq-7",
    questionNumber: 7,
    questionText: "With reference to the 'Kavach' automatic train protection system, consider the following statements:\n1. It was indigenously developed by the Research Designs and Standards Organisation (RDSO).\n2. It operates using RFID tags installed along the tracks and inside the locomotive cab.\nWhich of the statements given above is/are correct?",
    options: {
      A: "1 only",
      B: "2 only",
      C: "Both 1 and 2",
      D: "Neither 1 nor 2",
    },
    correctAnswer: "C",
    subject: "Science & Technology",
    topic: "Railway Safety & Indigenous Tech",
    difficulty: "Medium",
    explanation: "Kavach is an indigenously developed Automatic Train Protection (ATP) system created by RDSO in collaboration with Indian industry, utilizing UHF radio and RFID technology.",
    dateAdded: "2026-10-30",
    status: "Active",
  },
  {
    id: "pq-8",
    questionNumber: 8,
    questionText: "With reference to the India-Middle East-Europe Economic Corridor (IMEC), consider the following statements:\n1. It was unveiled on the sidelines of the G20 New Delhi Summit in 2023.\n2. It consists of two separate corridors: the East corridor and the Northern corridor.\nWhich of the statements given above is/are correct?",
    options: {
      A: "1 only",
      B: "2 only",
      C: "Both 1 and 2",
      D: "Neither 1 nor 2",
    },
    correctAnswer: "C",
    subject: "Current Affairs",
    topic: "Global Connectivity Initiatives",
    difficulty: "Medium",
    explanation: "IMEC was launched at the 2023 G20 Summit in New Delhi. It features an East corridor connecting India to the Arabian Gulf and a Northern corridor connecting the Gulf to Europe.",
    dateAdded: "2026-10-31",
    status: "Active",
  },
  {
    id: "pq-9",
    questionNumber: 9,
    questionText: "With reference to the cultural history of India, the 'Tandava' and 'Lasya' aspects are foundational to which classical art form?",
    options: {
      A: "Indian Classical Dance traditions",
      B: "Dhrupad vocal traditions",
      C: "Miniature painting schools",
      D: "Dravidian temple shikhara design",
    },
    correctAnswer: "A",
    subject: "Art & Culture",
    topic: "Natyashastra & Classical Dances",
    difficulty: "Easy",
    explanation: "According to Bharata Muni's Natyashastra, Indian classical dance has two primary aspects: Tandava (representing the masculine/energetic cosmic dance of Shiva) and Lasya (representing the graceful/lyrical aspect associated with Parvati).",
    dateAdded: "2026-11-01",
    status: "Active",
  },
];

export const initialMainsQuestionBank = [
  // GS Paper I
  {
    id: "mq-1",
    questionText: "The Bhakti Movement served as a socio-religious bridge across medieval India. Discuss its contribution to the evolution of regional languages and vernacular literature.",
    gsPaper: "GS Paper I",
    subject: "History",
    topic: "Bhakti Literature & Socio-Religious Reforms",
    maxMarks: 10,
    wordLimit: 150,
    difficulty: "Medium",
    referenceAnswer: "Structure:\n1. Introduction: Essence of Bhakti movement — direct devotional connect bypassing Sanskrit orthodoxy.\n2. Literary development: Tamil (Alvars/Nayanars), Kannada (Vachana sahitya), Marathi (Abhangas of Tukaram), Hindi (Kabir, Tulsidas), Bengali (Chaitanya movement).\n3. Social democratization: Inclusivity across caste, gender, and regional barriers.\n4. Conclusion: Lingual unification and birth of modern Indian literary traditions.",
    dateAdded: "2026-10-26",
    status: "Active",
  },
  {
    id: "mq-2",
    questionText: "Assess the vulnerability of Indian megacities to urban flooding. Suggest comprehensive structural and non-structural urban drainage management strategies.",
    gsPaper: "GS Paper I",
    subject: "Geography",
    topic: "Urban Flooding & Spatial Planning",
    maxMarks: 15,
    wordLimit: 250,
    difficulty: "Medium",
    referenceAnswer: "Structure:\n1. Introduction: Frequent urban floods (Chennai, Mumbai, Bengaluru, Delhi) caused by climate change + rapid concrete urbanism.\n2. Key Causes: Encroachment of wetlands, concretization preventing percolation, outdated stormwater networks, solid waste clogging drains.\n3. Solutions: Sponge city concept, desilting of major storm drains, strictly enforcing master plans, permeable pavements, and GIS-based early flood warning.",
    dateAdded: "2026-10-27",
    status: "Active",
  },
  {
    id: "mq-3",
    questionText: "Discuss how modernization and globalization have impacted traditional joint family systems and elderly care in urban India.",
    gsPaper: "GS Paper I",
    subject: "Indian Society",
    topic: "Family Structure & Demographic Changes",
    maxMarks: 10,
    wordLimit: 150,
    difficulty: "Easy",
    referenceAnswer: "Structure:\n1. Introduction: Shift from patriarchal joint households to nuclear families due to economic migration and individualism.\n2. Impacts on Elder Care: Social isolation, geriatric health crises, financial insecurity, proliferation of retirement homes.\n3. Policy measures: Maintenance and Welfare of Parents and Senior Citizens Act, community elder daycare, social pensions.",
    dateAdded: "2026-10-28",
    status: "Active",
  },

  // GS Paper II
  {
    id: "mq-4",
    questionText: "Critically evaluate the role of Departmentally Related Standing Committees (DRSCs) in securing executive accountability. Are they losing their effectiveness? Discuss with recent examples.",
    gsPaper: "GS Paper II",
    subject: "Indian Polity",
    topic: "Parliamentary Standing Committees & Oversight",
    maxMarks: 15,
    wordLimit: 250,
    difficulty: "Hard",
    referenceAnswer: "Structure:\n1. Introduction: Constitutional framework of committee scrutiny and legislative oversight.\n2. Roles: Clause-by-clause scrutiny of bills, non-partisan deliberation, budget examination.\n3. Contemporary Challenges: Reduced referral of key bills, declining average sittings, lack of public access to proceedings.\n4. Way Forward: Mandatory referral rule, institutional research wings, and tracking action-taken reports.",
    dateAdded: "2026-10-28",
    status: "Active",
  },
  {
    id: "mq-5",
    questionText: "E-Governance is not merely about digitizing administrative paperwork, but transforming citizen-centric service delivery. Discuss with special reference to Mission Karmayogi and UMANG.",
    gsPaper: "GS Paper II",
    subject: "Governance",
    topic: "Digital Public Goods & Citizen Service Delivery",
    maxMarks: 15,
    wordLimit: 250,
    difficulty: "Medium",
    referenceAnswer: "Structure:\n1. Introduction: Shift from process-centric to citizen-centric governance.\n2. UMANG as single unified multi-channel mobile gateway; DigiLocker for paperless authenticity.\n3. Mission Karmayogi: Competency-driven capacity building for civil servants.\n4. Key Challenges: Digital divide, data privacy issues, server latency in rural areas.\n5. Way forward: Interoperable digital architecture with strong grievance redressal.",
    dateAdded: "2026-10-29",
    status: "Active",
  },
  {
    id: "mq-6",
    questionText: "The 'Global South' has emerged as a central pillar of India's foreign policy calculus. Analyze the geopolitical opportunities and hurdles in India playing the voice of the Global South.",
    gsPaper: "GS Paper II",
    subject: "International Relations",
    topic: "Global South Diplomacy & Multilateralism",
    maxMarks: 15,
    wordLimit: 250,
    difficulty: "Hard",
    referenceAnswer: "Structure:\n1. Introduction: Voice of Global South Summit, G20 African Union induction under India's presidency.\n2. Geopolitical Opportunities: Bridge between developed North and developing nations, promoting DPI, championing vaccine diplomacy.\n3. Hurdles: Chinese economic inroads (BRI/Debt diplomacy), differing regional coalitions in Africa/Latin America.\n4. Conclusion: Strategic autonomy backed by multilateral reforms.",
    dateAdded: "2026-10-30",
    status: "Active",
  },

  // GS Paper III
  {
    id: "mq-7",
    questionText: "Examine the potential of Artificial Intelligence in revolutionizing agricultural practices in India. What are the key bottlenecks in scaling these technologies among smallholder farmers?",
    gsPaper: "GS Paper III",
    subject: "Indian Economy",
    topic: "Precision Farming & AI in Agriculture",
    maxMarks: 15,
    wordLimit: 250,
    difficulty: "Medium",
    referenceAnswer: "Structure:\n1. Introduction: Digital agriculture and AI opportunities (precision irrigation, pest detection, market linkage).\n2. Key applications: Drone surveillance, soil health analysis, AI-backed weather alerts.\n3. Bottlenecks: Fragmented landholdings, high initial costs, digital literacy, lack of localized vernacular datasets.\n4. Policy solutions: AgriStack integration, FPO-led digital infrastructure, Custom Hiring Centers.",
    dateAdded: "2026-10-30",
    status: "Active",
  },
  {
    id: "mq-8",
    questionText: "Explain the mechanism of Carbon Credit Trading under the Energy Conservation (Amendment) Act. How can it accelerate India's Net-Zero 2070 commitments?",
    gsPaper: "GS Paper III",
    subject: "Environment",
    topic: "Carbon Markets & Energy Transition",
    maxMarks: 15,
    wordLimit: 250,
    difficulty: "Hard",
    referenceAnswer: "Structure:\n1. Introduction: National Carbon Market framework under the Bureau of Energy Efficiency.\n2. Working: Obligated entities issued carbon credit certificates for exceeding emission targets, voluntary carbon offset trading.\n3. Net-Zero 2070 Linkage: Incentivizes renewable energy investments, decarbonizes hard-to-abate heavy industries (cement, steel).\n4. Safeguards needed: Strict monitoring, avoiding greenwashing, alignment with Article 6 of Paris Agreement.",
    dateAdded: "2026-10-31",
    status: "Active",
  },
  {
    id: "mq-9",
    questionText: "What are Large Language Models (LLMs)? Discuss the ethical, security, and intellectual property challenges arising from their rapid deployment in India.",
    gsPaper: "GS Paper III",
    subject: "Science & Technology",
    topic: "Artificial Intelligence & Generative Models",
    maxMarks: 15,
    wordLimit: 250,
    difficulty: "Medium",
    referenceAnswer: "Structure:\n1. Introduction: Definition of LLMs (deep neural architectures trained on massive corpora for predictive text).\n2. Applications: Education, governance, multilingual translation (Bhashini).\n3. Challenges: Copyright infringement of creative works, hallucination, algorithmic bias, deepfake proliferation, cyber threats.\n4. Regulatory response: Digital India Act, responsible AI guidelines, watermarking synthetic media.",
    dateAdded: "2026-11-01",
    status: "Active",
  },
  {
    id: "mq-10",
    questionText: "Cross-border narco-terror networks aided by unmanned aerial vehicles (drones) pose a grave threat to India's western frontier. Discuss measures to counter this asymmetric challenge.",
    gsPaper: "GS Paper III",
    subject: "Internal Security",
    topic: "Border Security & Drone Warfare",
    maxMarks: 10,
    wordLimit: 150,
    difficulty: "Medium",
    referenceAnswer: "Structure:\n1. Introduction: Rise of drone drops along Punjab and Jammu borders smuggling synthetic drugs, arms, and ammunition.\n2. Operational Challenges: Low radar cross-section of consumer drones, dark-hour flying, difficult riverine terrain.\n3. Countermeasures: Anti-drone systems (soft-kill radio jamming & hard-kill lasers), BSF night surveillance, village defense committees, coordinated intelligence sharing.",
    dateAdded: "2026-11-01",
    status: "Active",
  },

  // GS Paper IV
  {
    id: "mq-11",
    questionText: "'Ethical governance cannot be enforced solely through legal statutes; it requires deep-seated moral conscience.' In this context, discuss how emotional intelligence aids public servants in ethical decision-making.",
    gsPaper: "GS Paper IV",
    subject: "Ethics",
    topic: "Emotional Intelligence & Ethical Governance",
    maxMarks: 10,
    wordLimit: 150,
    difficulty: "Medium",
    referenceAnswer: "Structure:\n1. Introduction: Law sets minimum legal boundaries; ethics inspires the pursuit of moral good and compassion.\n2. Role of EI: Self-awareness against prejudice, emotional regulation under political duress, empathy toward marginalized citizens.\n3. Real-world civil service cases: Riot control with de-escalation, grievance hearing with patience, public welfare allocation.\n4. Conclusion: Synthesis of constitutional morality with emotional empathy.",
    dateAdded: "2026-10-29",
    status: "Active",
  },
  {
    id: "mq-12",
    questionText: "Distinguish between 'probity in governance' and 'administrative compliance'. Why is financial integrity alone insufficient for holistic integrity in public life?",
    gsPaper: "GS Paper IV",
    subject: "Integrity",
    topic: "Probity in Public Life",
    maxMarks: 10,
    wordLimit: 150,
    difficulty: "Hard",
    referenceAnswer: "Structure:\n1. Definitions: Administrative compliance is mechanical rule-following; probity is proactive devotion to honesty, public interest, and non-partisanship.\n2. Beyond Financial Integrity: Intellectual integrity, moral courage to give candid policy advice, non-nepotistic recruitment, dedication to constitutional values.\n3. Conclusion: Nolan Committee principles of openness, leadership, and accountability.",
    dateAdded: "2026-10-31",
    status: "Active",
  },
  {
    id: "mq-13",
    questionText: "Explain how 'cognitive dissonance' affects civil servants when administrative directives conflict with their personal moral convictions. How should a conscientious officer resolve such dilemmas?",
    gsPaper: "GS Paper IV",
    subject: "Aptitude",
    topic: "Moral Dilemmas & Cognitive Dissonance",
    maxMarks: 10,
    wordLimit: 150,
    difficulty: "Hard",
    referenceAnswer: "Structure:\n1. Definition: Cognitive dissonance as psychological discomfort when actions diverge from deeply held moral standards.\n2. Civil service contexts: Eviction drives without rehabilitation, executing orders perceived as partisan.\n3. Resolution pathway: Adhere to Constitutional morality first, put reservations on file formally, exhaust internal appeal channels, resign rather than commit outright illegal/unconstitutional acts.",
    dateAdded: "2026-11-02",
    status: "Active",
  },
];
